
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions/save-with-private-hire",
      function () {
        return require("private-next-pages/promotions/save-with-private-hire.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotions/save-with-private-hire"])
      });
    }
  